import { Component, Input } from '@angular/core';
import { SensorStatusesDescription } from '@app/shared';
import { MatRipple } from '@angular/material/core';
import { NgClass, NgStyle } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { NgxTolgeeModule } from '@tolgee/ngx';

export enum KeyStatuses {
	active = 'Active',
	expired = 'Expired',
}

// TODO refactoring it later
@Component({
	selector: 'au-status-label',
	templateUrl: './au-status-label.component.html',
	styleUrls: ['./au-status-label.component.scss'],
	imports: [MatRipple, NgClass, NgStyle, MatTooltip, NgxTolgeeModule],
})
export class AuStatusLabelComponent {
	@Input() status: SensorStatusesDescription | KeyStatuses;
	@Input() isClickable = false;
	@Input() tooltip = null;

	cssClassesMap = {
		[SensorStatusesDescription.notRunning]: 'bad-with-background',
		[SensorStatusesDescription.running]: 'good-with-background',
		[SensorStatusesDescription.analyzing]: 'gray-with-background',
		[SensorStatusesDescription.noData]: 'gray-with-background',

		[SensorStatusesDescription.online]: 'good-with-background',
		[SensorStatusesDescription.offline]: 'bad-with-background',
		[SensorStatusesDescription.inProgress]: 'in-progress',
		[SensorStatusesDescription.planned]: 'planned',

		[KeyStatuses.active]: 'good-with-background',
		[KeyStatuses.expired]: 'bad-with-background',
	};
}
